import gitJson from './git-version';

export const constants = {
  version: gitJson.semver.version,
  gitVersion: gitJson,
};
